import type { CreateProjectInput, UpdateProjectInput } from '@idc-forms/schemas'
import { axiosPrivate } from '@/shared/api/axios'
import { buildListQueryString } from '@/shared/api/build-list-query-string'
import { API } from '@/shared/constants/api'
import type {
  PaginatedProjects,
  ProjectAdminRow,
  ProjectsAdminParams
} from '../models/project-admin'

export async function getProjectsAdmin(params: ProjectsAdminParams): Promise<PaginatedProjects> {
  const qs = buildListQueryString(params)
  const { data } = await axiosPrivate.get<PaginatedProjects>(
    `${API.projects.root}${qs ? `?${qs}` : ''}`
  )
  return data
}

/** Los payloads son los MISMOS schemas Zod que valida el backend. */
export async function createProject(payload: CreateProjectInput): Promise<ProjectAdminRow> {
  const { data } = await axiosPrivate.post<ProjectAdminRow>(API.projects.root, payload)
  return data
}

export async function updateProject(
  id: string,
  payload: UpdateProjectInput
): Promise<ProjectAdminRow> {
  const { data } = await axiosPrivate.patch<ProjectAdminRow>(API.projects.byId(id), payload)
  return data
}

export async function deleteProject(id: string) {
  const { data } = await axiosPrivate.delete(API.projects.byId(id))
  return data
}
